import { useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const KEY = "sw-beta-dismissed";

export function BetaBanner() {
  const [hidden, setHidden] = useState(() => {
    try {
      return sessionStorage.getItem(KEY) === "1";
    } catch {
      return false;
    }
  });
  if (hidden) return null;
  return (
    <div className="beta-banner" role="status">
      <p>
        Live beta. Matching and USDT deposits work. Books are thin. Softwave is not a licensed exchange.{" "}
        <Link to="/trust">How trust works</Link>
      </p>
      <button
        type="button"
        className="icon-btn beta-dismiss"
        aria-label="Dismiss"
        onClick={() => {
          try {
            sessionStorage.setItem(KEY, "1");
          } catch {
            /* ignore */
          }
          setHidden(true);
        }}
      >
        <X size={16} />
      </button>
    </div>
  );
}
